module.exports = __webpack_public_path__ + "assets/img/download-420ed4e5.png";